module.exports = __webpack_public_path__ + "static/media/VGS_Phone_01.53ca384c.png";